﻿
import { AppConstants } from '../../constants/AppConstants';
//import BaseAPI from './BaseAPI';
import BaseActions from '../../app/_base_actions';
import Rest from '../../webapi/Rest';
import DOMAINS from '../../constants/Domini';
import OPZIONI from '../../constants/Opzioni';
import AppActions from '../../app/app_actions';
import { i18n } from 'arm-common';


const EnumAccountActions = Object.freeze({
    GET_VERSION: 'GET_VERSION',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGOUT: 'LOGOUT',
    SSO: 'SSO',
    LISTA_ACCESSI: 'LISTA_ACCESSI',
});


module.exports.EnumAccountActions = EnumAccountActions;

class AccountActions extends BaseActions {
    get Actions() {
        return EnumAccountActions;
    }
    constructor() {
        super();
        this.moduleName = "[AccountActions] ";
    }


    login(username, password) {
        console.log(this.moduleName + "login: " + username);
        return (dispatch, getState) => {
            dispatch(AppActions.clearNotify());
            const token = getState().account.token;
            console.log("[LoginActions] TOKEN: " + token);
            return Rest.postForm("authentication/login", {
                login: username,
                password: password,
                version: AppConstants.VERSIONE,
                applicationName: AppConstants.APP_CODE,  token: token
            }, dispatch).then(
                resolve => {
                    console.log('[AccountActions] login resolved');
                    //console.log("\tUser: " + JSON.stringify(resolve));
                    dispatch({ type: EnumAccountActions.LOGIN_SUCCESS, user: resolve });

                    console.log('[AccountActions] user codLang: ', resolve.codLang);
                    return resolve
                },
                reject => {
                    console.log('[AccountActions] getJSON: reject:');
                    dispatch({ type: EnumAccountActions.LOGIN_FAILED });
                    // location.reload()             
                    return reject;
                }
            ).then(resolve => {
                console.log('[AccountActions] login completata con successo e carico i domini .... ' + resolve.codLang);
                return Promise.all([
                    resolve,
                    dispatch(this.loadDomains()),
                    dispatch(this.loadI18nLabels(resolve.codLang)),
                    dispatch(this.loadOpzioni())
                ])

            });
        }

    };


    logout() {
        console.log('[AccountActions] logout');
        return function (dispatch) {
            return Rest.post("authentication/logout", null, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumAccountActions.LOGOUT });
                    // location.reload()                               
                    return resolve;
                }, function (reject) {
                    return reject;
                });
        }
    };



    loadDomains() {
        return AppActions.loadDomains(DOMAINS);
    }


    loadI18nLabels(lang) {
        return AppActions.loadI18nLabels(AppConstants.I18N_CODES, lang);
    }

    loadOpzioni() {
        return AppActions.loadOpzioni(OPZIONI);
    }

    updateUser(user) {
        return function (dispatch) {
            return Rest.post("account/updateProfile", user, dispatch).then(
                function (resolve) {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM.CORE.PRODUCT.PROFILE.UPDATE','Profilo utente modificato con successo')));
                    return resolve;
                },
                function (reject) {
                    return reject;
                });
        }
    }

    updateDefaultLanguage(codLang, userId) {
        return function (dispatch) {
            return Rest.postForm("account/saveDefaultLangById", { codLang: codLang, userId: userId }, dispatch).then(
                function (resolve) {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM.CORE.PRODUCT.PROFILE.UPDATE', 'Profilo utente modificato con successo')));
                    return resolve;
                },
                function (reject) {
                    return reject;
                });
        }

    }

    changePassword(oldPassword, newPassword) {
        return function (dispatch, getState) {
            return Rest.postForm("account/changePassword",
                {
                    userId: getState().account.utente.userId,
                    oldPassword: oldPassword,
                    newPassword: newPassword
                }, dispatch).then(
                    function (resolve) {
                        if (resolve.codice === 'KO') {
                            dispatch(AppActions.addNotify('DANGER', i18n('ARM_CORE_PRODUCT.ACCOUNT.MAIL_MANCANTE', 'Attenzione non è stato possibile recapitare la mail per la modifica password')));
                        } else {
                            dispatch(AppActions.addNotify('SUCCESS', 'Password modificata con successo'));
                        }
                        return resolve;
                    },
                    function (reject) {
                        return reject;
                    });
        }
    }

    resetPassword(userid, email) {
        return function (dispatch) {
            return Rest.postForm("account/resetPassword",
                {
                    userId: userid,
                    email: email
                }, dispatch).then(
                    function (resolve) {
                        dispatch(AppActions.addNotify('WARNING', 'Ti abbiamo inviato una password temporanea al seguente indirizzo email ' + email));
                        return resolve;
                    },
                    function (reject) {
                        return reject;
                    });
        }
    }

    getVersione() {
        return function (dispatch, getState) {
            return Rest.get('authentication/version', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumAccountActions.GET_VERSION, result: resolve })
                }
            );
        }
    }

    getListaAccessiUtente(userId, limitAccessi) {
        return function (dispatch, getState) {
            //let user = getState().userReducer.utentebo;
            return Rest.postForm("account/listaAccessi", { userid: userId, limitAccessi: limitAccessi }, dispatch).then(
                resolve => {
                    //user.listaAccessi = resolve;
                    dispatch({ type: EnumAccountActions.LISTA_ACCESSI, listaAccessi: resolve });
                    return resolve;
                }, reject => {
                    return reject;
                });

        };
    }

    sso(otssoToken) {
        console.log(this.moduleName + "sso");

        return (dispatch) => {
            const opts = { loadNoDelay: true };
            return Rest.postForm("authentication/sso", { otssoToken: otssoToken, applicationName: AppConstants.APP_NAME }, dispatch, opts,).then(
                (resolve) => {
                    console.log("[AccountActions.js] sso resolve", resolve);
                    dispatch({ type: EnumAccountActions.SSO, datiUtente: resolve });
                    return resolve;
                },
                (reject) => {
                    console.warn("[AccountActions.js] sso reject");
                    return reject;
                },
            );
        }
    }

}

export default AccountActions = new AccountActions;